
export const isEmpty = ( value ) => {

	if( value === '' || value === null || value === undefined
		|| ( value !== null && typeof value === "object" && !Object.keys(value).length ) ) {
		return true;
	}

	return false;

}

/**

 * 지정한 범위의 랜덤값을 구한다.
 * @param {} n1
 * @param {} n2
 * @return {}
 */
export const random = (start, end) =>{
	return Math.floor( (Math.random() * (end - start + 1)) + start );
}
  

//--------------------------------
// UUID 생성
//--------------------------------
export const getUUID = () => {

	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
	  var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 3 | 8);
	  return v.toString(16);
	});
  	
}